import { useState } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { useAuth } from '../hooks/useAuth';
import '../styles.css';
import { API_URL } from '../config';

function Login() {
  console.log('Rendering Login');
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log('Login: handleLogin called with', { email });
    setError(''); // Clear any previous errors
    try {
      const response = await axios.post(`${API_URL}/api/login`, { email, password });
      console.log('Login response:', response.data);
      
      const { token, refreshToken, user, is_admin } = response.data;
      console.log('Calling login function with:', { token: token ? 'Present' : 'Missing', refreshToken: refreshToken ? 'Present' : 'Missing', user, is_admin });
      
      login(token, refreshToken, { ...user, is_admin });
      console.log('Login function called successfully');
      
      const redirectPath = is_admin ? '/admin' : '/question-of-the-day';
      console.log('Navigating to:', redirectPath);
      window.location.href = redirectPath;
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <Layout>
      <div className="login-container">
        {/* Login Form - Moved to Top */}
        <div className="login-form-section" style={{
          maxWidth: '400px',
          margin: '0 auto 30px',
          backgroundColor: '#fff',
          padding: '15px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#333', fontSize: '1.5rem' }}>
            Login to True Devotion
          </h2>
          {error && <p className="error">{error}</p>}
          <form onSubmit={handleLogin}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '12px',
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '15px',
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box'
              }}
            />
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '10px',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Login
            </button>
          </form>
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <p style={{ margin: '8px 0' }}>
              <a href="/signup" onClick={(e) => { e.preventDefault(); window.location.href = '/signup'; }}
                 style={{ color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>
                Need an account? Sign up
              </a>
            </p>
            <p style={{ margin: '8px 0' }}>
              <a href="/reset-password" onClick={(e) => { e.preventDefault(); window.location.href = '/reset-password'; }}
                 style={{ color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>
                Forgot Password?
              </a>
            </p>
          </div>
        </div>

        {/* Hero Section - Moved Below Login */}
        <div className="hero-section" style={{
          textAlign: 'left',
          marginBottom: '20px',
          padding: '0 10px'
        }}>
          <h1 style={{ 
            fontSize: '1.2rem', 
            marginBottom: '8px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            lineHeight: '1.2'
          }}>
            Win Her Heart Daily
          </h1>
          <p style={{ 
            fontSize: '1rem', 
            color: '#666', 
            marginBottom: '20px',
            fontWeight: '500',
            lineHeight: '1.3'
          }}>
            Build trust. Give better gifts. Never forget what she loves.
          </p>
          
          {/* 3-Step Guide - Compact Inline Layout */}
          <div className="steps-guide" style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            maxWidth: '100%'
          }}>
            <div className="step" style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              border: '1px solid #f0f0f0'
            }}>
              <div style={{ fontSize: '1.8rem', marginRight: '12px', flexShrink: 0 }}>📧</div>
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 4px', color: '#333', fontSize: '1rem', fontWeight: '600' }}>
                  1) Sign up free
                </h3>
                <p style={{ margin: '0', color: '#666', fontSize: '0.85rem', lineHeight: '1.3' }}>
                  Get daily questions delivered to your inbox
                </p>
              </div>
            </div>
            
            <div className="step" style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              border: '1px solid #f0f0f0'
            }}>
              <div style={{ fontSize: '1.8rem', marginRight: '12px', flexShrink: 0 }}>❓</div>
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 4px', color: '#333', fontSize: '1rem', fontWeight: '600' }}>
                  2) Ask her the question
                </h3>
                <p style={{ margin: '0', color: '#666', fontSize: '0.85rem', lineHeight: '1.3' }}>
                  Jot her answer. It saves encrypted. Totally private.
                </p>
              </div>
            </div>
            
            <div className="step" style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              border: '1px solid #f0f0f0'
            }}>
              <div style={{ fontSize: '1.8rem', marginRight: '12px', flexShrink: 0 }}>👑</div>
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 4px', color: '#333', fontSize: '1rem', fontWeight: '600' }}>
                  3) Subscribe for AI Advisor
                </h3>
                <p style={{ margin: '0', color: '#666', fontSize: '0.85rem', lineHeight: '1.3' }}>
                  Get AI-powered gift ideas and premium features
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Login;